window.getRandomString = () => {
  return new Date().getTime()
}

import('./bootstrap')
